import * as tslib_1 from "tslib";
import { action } from 'satcheljs/lib/legacy';
import store from '../store/store';
import setConsumerMailboxOptions from '../services/setConsumerMailboxOptions';
import { isConsumer } from 'owa-session-store';
export default action('savePopImapConfiguration')(function savePopImapConfiguration(popImapConfiguration) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var consumerMailboxOptions;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    store.popEnabled = popImapConfiguration.popEnabled;
                    store.popMessageDeleteEnabled = popImapConfiguration.popMessageDeleteEnabled;
                    if (!isConsumer()) return [3 /*break*/, 2];
                    consumerMailboxOptions = {
                        PopEnabled: store.popEnabled,
                        PopMessageDeleteEnabled: store.popMessageDeleteEnabled,
                    };
                    return [4 /*yield*/, setConsumerMailboxOptions(consumerMailboxOptions)];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    });
});
//# sourceMappingURL=savePopImapConfiguration.js.map